import React from 'react'
import styled from 'styled-components'

const CheckboxContainer = styled.div`
  text-align: right;
  flex-grow: 0;
  margin-left: 8px;
`

const Checkbox = ({ onChange, checked }) =>
  <CheckboxContainer><input type='checkbox' onChange={onChange} checked={checked} /></CheckboxContainer>

export default Checkbox
